var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({ref:"expandContainer",staticClass:"x-expand-container",style:(_vm.hasLoaded ? `height: ${this.height}px` : '')},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{ref:"contentContainer"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }